'use strict';
var monitoringAlarmListTpl = require('./alarmList.html');
var util = require('../../../util/property-util');

module.exports = {
    template: monitoringAlarmListTpl,
    bindings: {
        alarms: '<',
        onLeftClick: '&',
        onRaiseIncidentClick: '&', // on Raise Incident click ( context menu )
        sortingObj: '<'
    },
    controllerAs: 'vm',
    controller: /*@ngInject*/ ["$scope","NgTableParams", "$filter", 'ProjectService', 'ZabbixOverviewFactory', 'ZabbixIssueFactory', 'MonitoringStoreService', 'ConfigurationStoreService', "$stateParams",
    function($scope, NgTableParams, $filter, ProjectService, ZabbixOverviewFactory, ZabbixIssueFactory, MonitoringStoreService, ConfigurationStoreService, $stateParams) {
        var vm = this;

        vm.isIntegratedConsole = ProjectService.getSelectedProjectId() === 0 ? true : false;

        var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
        vm.isPaintedCoach = projectConfiguration && !projectConfiguration.paintedCoach;
    
        vm.headers = [{
            label: 'PROJECT',
            field: 'projectName',
            icon: 'fa-folder',
            show: vm.isIntegratedConsole
        },
        {
            label: 'TRAIN',
            field: 'trainOfficialId',
            icon: 'fa-train',
            show: true
        },
        {
            label: 'SEVERITY',
            field: 'severity',
            icon: 'fa-exclamation-triangle',
            show: true
        },
        {
            label: 'DEVICE',
            field: 'deviceName',
            icon: 'fa-plug',
            show: true
        },{
            label: 'DESCRIPTION',
            field: 'description',
            icon: 'fa-book',
            show: true
        },
        {
            label: 'Car Number',
            field: 'paintedCoachId',
            icon: 'fa-book',
            show: vm.isPaintedCoach
        },
        {
            label: 'DATE',
            field: 'lastChange',
            icon: 'fa-calendar',
            show: true
        },
        {
            label: 'ACKNOWLEDGED',
            field: 'acknowledged',
            icon: 'fa-thumbs-up',
            show: true
        },{
            label: 'INCIDENT',
            field: 'incidentId',
            icon: 'fa-thumbs-up',
            show: true
        }, {
                label: 'STATUS',
                field: 'incidentStatus',
                icon: 'fa-thumbs-up',
                show: true
            }
        ];

        vm.allChecked = false;
        vm.checkedAlarms = {};
        vm.selectedAlarm;
        vm.disabled = false;
        vm.rfEnabled;
        vm.projectId = ProjectService.getSelectedProjectId()  || $stateParams.projectId;
        vm.isIntegratedConsole = vm.projectId == 0 ? true : false;
        vm.isPaintedCoach;

        var incidentURL;


        var firstClickedIdx;
        var secondClickedIdx;

        $scope.$on('ngRepeatFinished', function () {
            vm.dataRendered = true;
        });

        vm.$onInit = function () {
            setCheckStateAllAlarms(vm.allChecked);
            vm.alarmsTblParams = new NgTableParams({
                page: 1,            // show first page
                count: 500,          // count per page
                filter: {},
                sorting: (vm.sortingObj ? vm.sortingObj : { severity: 'desc' })
            }, {
                    counts: vm.alarms && vm.alarms.length <= 10 ? [] : [10, 25, 50, 100, 500],
                    total: (vm.alarms ? vm.alarms.length : 0), // length of data                
                    getData: function (params) {

                        var sortedData = params.sorting() ?
                            $filter('orderBy')(vm.alarms, params.orderBy()) :
                            vm.alarms;

                        params.total(sortedData && sortedData.length);
                      
                        vm.displayedData = sortedData && sortedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
                        return vm.displayedData;

                    }.bind(vm)
                });
        };

        vm.$onChanges = function() {
            projectConfiguration = ConfigurationStoreService.getProjectConfiguration(vm.projectId);
            if (projectConfiguration) {

                vm.isPaintedCoach = projectConfiguration.paintedCoach;
    
                if (projectConfiguration.remedyForceConfiguration) {
                    vm.rfEnabled = projectConfiguration.remedyForceConfiguration.rfEnabled;
                    incidentURL = projectConfiguration.remedyForceConfiguration.incidentUrl;
                }
            }
            vm && vm.alarmsTblParams && vm.alarmsTblParams.reload();
        };

        vm.sortData = function(field, event) {

            var sortingValObj = (event.shiftKey ? vm.alarmsTblParams.sorting() : {});

            if (sortingValObj.hasOwnProperty(field)) {
                sortingValObj[field] = ((sortingValObj[field] === 'asc') ? 'desc' : 'asc');
            } else {
                sortingValObj[field] = (vm.alarmsTblParams.isSortBy(field, 'asc') ? 'desc' : 'asc');
            }

            vm.alarmsTblParams.sorting(sortingValObj);
            vm.alarmsTblParams.reload();
        };

        vm.onAlarmLeftClick = function(event, alarm, idx) {
            event.preventDefault() && event.stopPropagation();
            if (event.shiftKey || event.ctrlKey || event.metaKey) {
                var selectedAlarms = vm.alarms.filter(function(alarmItem){
                    return  vm.checkedAlarms[alarmItem.eventId];
                });

                if (selectedAlarms.length === 0) { // first selected alarm
                    vm.checkedAlarms[alarm.eventId] = !vm.checkedAlarms[alarm.eventId];
                    firstClickedIdx = idx;
                } else if (event.shiftKey) {

                    secondClickedIdx = idx;
                    var start = firstClickedIdx < secondClickedIdx ? firstClickedIdx : secondClickedIdx;
                    var end = firstClickedIdx > secondClickedIdx ? firstClickedIdx : secondClickedIdx;

                    if (start !== end) {
                        var groupAlarms = vm.displayedData.slice(start, end + 1);
                        setCheckStateAllAlarms(false);
                        var selectedTrain; 
                        var hasSelectedDifferentTrains = false;
                        groupAlarms.forEach(function(alarmItem) {
                            if (alarmItem.eventId) {
                                if (selectedTrain && selectedTrain !== alarmItem.trainId) {
                                    hasSelectedDifferentTrains = true;
                                } else {
                                    selectedTrain = alarmItem.trainId;
                                    vm.checkedAlarms[alarmItem.eventId] = true;
                                }
                            }         
                        });
    
                        if (hasSelectedDifferentTrains) {
                            alert('Only alarm for the first selected train have been selected !!');
                        }
                    } else {
                        setCheckStateAllAlarms(false);
                    }

                } else {
                    if (selectedAlarms[0].trainId === alarm.trainId)  { // alarms are for the same train
                        vm.checkedAlarms[alarm.eventId] = !vm.checkedAlarms[alarm.eventId];
                    } else {
                        alert('Cannot select different trains for create a single RD incident');
                    }
                }

            } else {
                vm.onLeftClick({ alarm: alarm });   
            }          
        };
    
        function setCheckStateAllAlarms (checked) {
            vm.alarms && vm.alarms.forEach(function(alarm) {
                if (alarm.eventId) {
                    vm.checkedAlarms[alarm.eventId] = checked;
                }         
            });
        }

        vm.onBeforeContextMenuShow = function(alarm) {
            vm.selectedAlarm = alarm;
            if (vm.selectedAlarm && vm.selectedAlarm.eventId == -1) {
                vm.disabled = true;
            } else {
                vm.disabled = false;
            }
        };

        function getSelectedAlarms() {
            return vm.alarms.filter(function(alarmItem){
                return vm.checkedAlarms[alarmItem.eventId];
            });
        }

        vm.onContextMenuRaiseIncidentClick = function() {
            var incidentObject;
            
            var selectedAlarms = getSelectedAlarms();
            if (selectedAlarms.length > 0) { // has selected alarms
                incidentObject = Object.assign({}, selectedAlarms[0]);
                incidentObject.linkedEventIds = [
                    selectedAlarms[0].eventId
                ];
                selectedAlarms.forEach(function(alarmItem, idx){
                    if (idx > 0 ) {
                        incidentObject.description += '\n' + alarmItem.description;
                        incidentObject.severity = incidentObject.severity >= alarmItem.severity ? incidentObject.severity : alarmItem.severity;
                        incidentObject.linkedEventIds.push(alarmItem.eventId);
                    }
                });
            } else { // clicked alarm is the one targeted only
                incidentObject = Object.assign({}, vm.selectedAlarm);
                incidentObject.linkedEventIds = [
                    vm.selectedAlarm.eventId
                ];
            }

            vm.onRaiseIncidentClick({ alarm: incidentObject }); 
        };

        vm.onContextMenuInvestigateZabbixClick = function() {
            
            var selectedAlarms = getSelectedAlarms();
            var multipleSelected = false;
            var zabbixURL;

            // Here the train Id of a single alarm record is picked when multiple alarms are selected
            // as there is a validation that user can select multiple alarms of the same train
            // so selectedAlarms will have all the alarm records with same trainId
            if(selectedAlarms && selectedAlarms.length > 0) {
                zabbixURL = selectedAlarms[0].zabbixURL;
                multipleSelected = true;
            } else if(vm.selectedAlarm) {
                zabbixURL = vm.selectedAlarm.zabbixURL;
            } else {
                return;
            }

            if (util.isDefined(zabbixURL)) {
                // responseData.message is Zabbix Config Full URL -> http://vmtrainzabbix01.ovh.21net.com/api_jsonrpc.php

                var matchedResult = zabbixURL.match(/^https?:\/\/[^#?\/]+(:?\/zabbix)*/);
                if (matchedResult) {
                    // matchedResult[0] is Zabbix Base URL -> http://vmtrainzabbix01.ovh.21net.com

                    openZabbixURLinNewTab(matchedResult[0], (multipleSelected ? selectedAlarms : vm.selectedAlarm));
                        
                } else {
                    alert('Could not get Zabbix configuration Base URL');
                }

            } else {
                alert('Zabbix configuration URL not found for selected train');
            }

        }; 

        function openZabbixURLinNewTab(zabbixBaseURL, alarm) {
            if (alarm) {                
                // target URL example -> http://vmtrainzabbix01.ovh.21net.com/tr_events.php?triggerid=120867&eventid=247981663

                if(alarm instanceof Array) {
                    for(var i = 0; i < alarm.length; i++) {
                        window.open(zabbixBaseURL + '/tr_events.php?triggerid=' + alarm[i].triggerId + '&eventid=' + alarm[i].eventId);
                    }
                } else {
                    window.open(zabbixBaseURL + '/tr_events.php?triggerid=' + alarm.triggerId + '&eventid=' + alarm.eventId);
                }
            }            
        }

        vm.onContextMenuAcknowledgeClick = function () {

            // if the alarm hasn't been acknowledged yet, fire the ack request!
            if (vm.selectedAlarm && !vm.selectedAlarm.acknowledged) {

                // zabbix-alarm or noc-alarm
                if (util.isDefined(vm.selectedAlarm.type)) {

                    ZabbixOverviewFactory.postAcknowledgement(vm.selectedAlarm.projectId, vm.selectedAlarm.trainId, [ vm.selectedAlarm.eventId ], vm.selectedAlarm.type).then(function () {
                        //vm.selectedAlarm.acknowledged = true;
                        MonitoringStoreService.updateTrainAlarms(vm.selectedAlarm.trainId, vm.selectedAlarm);
                    });
                }
            }
        };


        vm.onContextMenuCloseClick = function () {
            // if the alarm hasn't been acknowledged yet, fire the ack request!
            if (vm.selectedAlarm && vm.selectedAlarm.type === 'nms-alarm' && vm.selectedAlarm.acknowledged) {

                ZabbixIssueFactory.deleteAlarmEvent(ProjectService.getSelectedProjectId(), vm.selectedAlarm.description, vm.selectedAlarm.trainId, vm.selectedAlarm.boxId).then(function (){

                    MonitoringStoreService.deleteTrainAlarms(vm.selectedAlarm.trainId, vm.selectedAlarm);
                });
            }
        };

        vm.onIncidentIdClick = function (incidentPK) {
            if (incidentURL) {
                window.open(incidentURL.replace("ID", incidentPK));
            } else {
                alert('RemedyForce URL is not found in Project Configuration');
            }
        };

    }]  // controller end  
};
